import Icon from '../components/Icon';
// src/pages/Login.js
import React from 'react';

export default function Login({ onLogin }) {
  return (
    <div className="login-page">
      <div className="login-outer">
        <div className="login-left">
        {/* Decorative diagonal chevrons */}
        <svg aria-hidden="true" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }} viewBox="0 0 320 540" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
          {/* Top-right large chevron */}
          <polygon points="320,0 320,220 180,0" fill="rgba(255,255,255,0.06)" />
          <polygon points="320,0 320,160 240,0" fill="rgba(255,255,255,0.05)" />
          {/* Bottom-left shadow wedge */}
          <polygon points="0,540 0,340 160,540" fill="rgba(0,0,0,0.12)" />
          <polygon points="0,540 0,420 80,540" fill="rgba(0,0,0,0.08)" />
        </svg>
          <div className="login-left-crest">
            <Icon size={52} />
          </div>
          <div className="login-left-welcome">Welcome to the</div>
          <div className="login-left-name">SUFC Secure<br />Transfer System</div>
          <div className="login-left-desc">
            The authorised platform for sharing sensitive files with external parties.
          </div>
        </div>
        <div className="login-right">
          <div className="login-right-heading">Sign in to continue</div>
          <div className="login-right-sub">
            Use your Sheffield United Microsoft 365 account to access the system.
          </div>
          <div className="login-features">
            <div className="login-feature"><div className="login-feature-dot" />Email OTP verification — recipients prove identity before downloading</div>
            <div className="login-feature"><div className="login-feature-dot" />Automatic link expiry from 1–5 days, instant expiry after download</div>
            <div className="login-feature"><div className="login-feature-dot" />Full audit trail of all access and downloads for compliance</div>
            <div className="login-feature"><div className="login-feature-dot" />View-only mode for PDFs — share without allowing download</div>
          </div>
          <button className="btn btn-primary btn-xl" style={{ width: '100%', justifyContent: 'center' }} onClick={onLogin}>
            Sign in with Microsoft 365
          </button>
          <div className="login-footer-note">Access restricted to authorised SUFC staff only</div>
        </div>
      </div>
    </div>
  );
}
